import { render, staticRenderFns } from "./trainerstable.vue?vue&type=template&id=8c260f98"
import script from "./trainerstable.vue?vue&type=script&lang=js"
export * from "./trainerstable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports